import { render, staticRenderFns } from "./Zhuan.vue?vue&type=template&id=5c2b4014&scoped=true&"
import script from "./Zhuan.vue?vue&type=script&lang=js&"
export * from "./Zhuan.vue?vue&type=script&lang=js&"
import style0 from "./Zhuan.vue?vue&type=style&index=0&id=5c2b4014&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2b4014",
  null
  
)

export default component.exports